<template>
    <div style="margin-bottom: 140px">
       
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },

    methods: {
        
    },

    mounted() {
    if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPad/i))) {
          window.location = "https://apps.apple.com/cy/app/black-pizza/id1498371417";
      }

      if((navigator.userAgent.match(/Android/i))) {
          window.location = "https://play.google.com/store/apps/details?id=com.oakmont.blackpizza";
      }
    }
}
</script>
